import { ScrollArea } from "@/components/ui/scroll-area";

type TipsContentProps = {
    content: string;
};

const TipsContent = ({ content }: TipsContentProps) => (
    <ScrollArea className="h-25 pr-2">{content}</ScrollArea>
);

export default TipsContent;
